import { css } from 'styled-components';

// Useful inside styled components styles to generate flex-basis from an array
// of sizes.
// Usage: <Component columns={['25%', '75%']} ...
// Usage: <Component columns="33.333333%" ...
export default function flexColumns(columns = null) {
  if (columns === null) {
    return;
  }

  if (typeof columns === 'string' || typeof columns === 'number') {
    return css`
      > * { flex: 0 0 ${columns}; }
    `;
  }

  return columns.map((column, index) => css`
    > *:nth-child(${index + 1}) {
      flex: 0 0 ${column};
    }
  `);
}
